import styled from '@emotion/styled'
import * as React from 'react'

import { Close } from '../../atoms/close'

export type ModalHeaderProps = {
  children?: React.ReactNode
  onClickClose?: () => void
}

const StyledBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--White97);
  padding: 36px 16px 36px 36px;
  border-bottom: 1px solid var(--White90);
`

const StyledTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  flex-grow: 1;
`

export const ModalHeader = ({ children, onClickClose }: ModalHeaderProps) => (
  <StyledBox>
    <StyledTitle>{children}</StyledTitle>
    <Close onClick={onClickClose} />
  </StyledBox>
)
